import polyglotI18nProvider from "ra-i18n-polyglot";
import { TranslationMessages } from "react-admin";

import raDeMessages from "./ra-de-messages";
import domainDeMessages from "./domain-de-messages";

const germanMessages: TranslationMessages = {
  ...raDeMessages,
  ...domainDeMessages,
};

const i18nProvider = polyglotI18nProvider(() => germanMessages, "de");

export default i18nProvider;
